if (!customElements.get('author-feed')) {
  class AuthorFeed extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url) return;

      this.list = this.querySelector('[data-author-feed-list]');
      this.moreButton = this.querySelector('[data-author-feed-more]');
      this.moreButton.addEventListener('click', () => this.load(this.nextPage, false));
      this.load(1, true);
    }

    async load(page, replace) {
      this.moreButton.disabled = true;

      try {
        const url = new URL(this.dataset.url, window.location.origin);
        url.searchParams.set('view', 'author-feed');
        url.searchParams.set('page', page);

        const response = await fetch(url);
        if (!response.ok) return;

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const feedPage = doc.querySelector('[data-author-feed-page]');
        if (!feedPage) return;

        const cards = [...feedPage.children];
        if (replace) {
          if (!cards.length) return;
          this.list.replaceChildren(...cards);
          this.querySelector('[data-author-feed-empty]')?.remove();
        } else {
          this.list.append(...cards);
        }

        this.nextPage = Number(feedPage.dataset.nextPage) || null;
        this.moreButton.hidden = !this.nextPage;
      } catch (error) {
        // Network failure: the server-rendered feed and the archive link remain usable.
      } finally {
        this.moreButton.disabled = false;
      }
    }
  }

  customElements.define('author-feed', AuthorFeed);
}
